module.exports = "pegasus/assets/blocks/header-2-tech.png";